var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvedBorder02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.8 238.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.3 2s-96.2-13.8-96.2 110.7S1.5 237.1 1.5 237.1",
    fill: "none",
    stroke: "#ec4b24",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: 12
  })));
}
export default SvgCurvedBorder02;